import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetServerConfigurationResponse } from "./GetServerConfigurationResponse";

const ENDPOINT = "/options/server_configuration";

export class GetServerConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetServerConfigurationResponse> {
        var res = await this.executeCommand();
        return new GetServerConfigurationResponse(res);
    }
}
